/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { RenderRichContent } from "./RenderRichContent/RenderRichContent"
import { CookieConsent as CookieBanner } from "react-cookie-consent"
import {
  Cookies,
  getCookieConsentValue,
  CookieConsent,
} from "react-cookie-consent"
import "./layout.scss"
import "../styles/global.css"
import { CookieSettings } from "./Cookie/cookieSettings"
import NewHeader from "./newHeader/newHeader"
import Footer from "./footer/footer"
import { useLocation } from "@reach/router"


import PopUpBrowserLanguage from "./PopUp/PopupBrowserLanguage"

const Layout = ({ children, urlContent, header, footer }) => {
  const locale = process.env.language
  let headerData
  let footerData
  let cookieData

  const location = useLocation()

  const urlParams = new URLSearchParams(decodeURIComponent(location.search))

  if (urlParams.get("utm_source") !== null) {
    sessionStorage.setItem("utm_source", urlParams.get("utm_source"))
  }
  if (urlParams.get("utm_medium") !== null) {
    sessionStorage.setItem("utm_medium", urlParams.get("utm_medium"))
  }
  if (urlParams.get("utm_campaign") !== null) {
    sessionStorage.setItem("utm_campaign", urlParams.get("utm_campaign"))
  }
  if(urlParams.get("utm_content") !== null) {
    sessionStorage.setItem("utm_content", urlParams.get("utm_content"))
  }

  const dataLayer =
    typeof window !== "undefined" ? window.dataLayer || [] : null

  useEffect(() => {
    const isConsent = getCookieConsentValue()
    if (isConsent === "true") {
      document.documentElement.classList.remove("overflow-hidden")
    } else {
      document.documentElement.classList.add("overflow-hidden")
    }
  }, [])

  function removeOverflow() {
    const consentTrue = getCookieConsentValue()
    if (consentTrue === "true") {
      document.documentElement.classList.remove("overflow-hidden")
    }
  }

  const data = useStaticQuery(graphql`
    query SiteTitleQuery($locale: String) {
      allContentfulContentBlockCookie {
        nodes {
          cookieChoiceButton
          cookieAcceptButtonText
          cookiesExplainerOptions {
            raw
          }
          cookiesMandatoryExplainer {
            raw
          }
          cookiesMandatoryHeader
          marketingCookiesExplainer {
            raw
          }
          marketingCookiesHeader
          preferenceCookiesExplainer {
            raw
          }
          preferenceCookiesHeader
          socialMediaCookiesExplainer {
            raw
          }
          socialMediaCookiesHeader
          statisticalCookiesExplainer {
            raw
          }
          statisticalCookiesHeader
          title {
            raw
          }
          titleChoice {
            raw
          }
          cookieExplainer {
            raw
          }
        }
      }

      AllLocale: allContentfulEdc22ContentBlockEdCCommercialHeader {
        nodes {
          popUpText {
            raw
          }
          node_locale
          dropdownEnglish
          dropdownDutch
          dropdownGerman
        }
      }

      allContentfulEdc22ContentBlockEdCCommercialHeader(
        filter: { node_locale: { eq: $locale } }
      ) {
        edges {
          node {
            internalBlockName
            languageSwitchLanguageCode
            languageSwitchUrls
            loginLink
            registerLinkText
            registerLink
            trackLogin
            loginLinkText
            supportLink
            supportLinkText
            node_locale
            icon {
              description
              file {
                url
              }
            }
            headerLinks {
              menuItemNameLink {
                raw
              }
              menuItemSubs {
                menuItemNameLink {
                  raw
                }
                subCategoryMenuItemsHeading {
                  raw
                }
                subCategoryMenuItems{
                menuItemNameLink {
                  raw
                }
                }
              }
            }
            searchLink {
              slug
            }
            menuButtons {
              buttonColor
              buttonText
              buttonUrl
              internalPageReference {
                ... on ContentfulEdc22ContentPageContactDemoForm {
                  id
                  slug
                }
                ... on ContentfulEdc22OverviewPageCasesAndReferences {
                  id
                  slug
                }
                ... on ContentfulPageAccountDetail {
                  id
                  slug
                }
              }
            }
            currentLanguage
          }
        }
      }
      allContentfulEdc22ContentBlockFooter(
        filter: { node_locale: { eq: $locale } }
      ) {
        edges {
          node {
            newsletterHeaderText
            newsletterHubspotForm {
              raw
            }
            newsletterSubheader
            loginLink
            loginText
            trackLogin
            supportLink
            supportText
            node_locale
            dutchviewLogo {
              description
              file {
                url
              }
            }
            footerContact {
              raw
            }
            footerIsoImages {
              file {
                url
              }
              description
            }
            footerSectors {
              raw
            }
            footerSitemap {
              raw
            }
            footerSocialMedia {
              image {
                file {
                  url
                }
                description
              }
              imageLink
            }
            footerDownloadLinks {
              image {
                description
                file {
                  url
                }
              }
              imageLink
            }
            iso27001Pdf {
              file {
                url
                contentType
              }
              contentful_id
            }
            iso9001Pdf {
              file {
                url
                contentType
              }
              contentful_id
            }
            footerLegalLinks {
              raw
            }
          }
        }
      }
    }
  `)

  if (locale === "nl") {
    headerData = data.allContentfulEdc22ContentBlockEdCCommercialHeader.edges[0]
    footerData = data.allContentfulEdc22ContentBlockFooter.edges[0]
    cookieData = data.allContentfulContentBlockCookie.nodes[0]
    console.log(headerData)
  } else if (locale === "en") {
    headerData = data.allContentfulEdc22ContentBlockEdCCommercialHeader.edges[1]
    footerData = data.allContentfulEdc22ContentBlockFooter.edges[1]
    cookieData = data.allContentfulContentBlockCookie.nodes[1]
    console.log(headerData)
  } else if (locale === "de") {
    headerData = data.allContentfulEdc22ContentBlockEdCCommercialHeader.edges[2]
    footerData = data.allContentfulEdc22ContentBlockFooter.edges[2]
    cookieData = data.allContentfulContentBlockCookie.nodes[2]
    console.log(headerData)
  } else if (locale === "en-US") {
    headerData = data.allContentfulEdc22ContentBlockEdCCommercialHeader.edges[3]
    footerData = data.allContentfulEdc22ContentBlockFooter.edges[3]
    cookieData = data.allContentfulContentBlockCookie.nodes[3]
    console.log(headerData)
  }

  let settingScreen
  const [settingScreenOpen, setOpen] = useState(false)

  let customizeButton = (
    <button
      className=""
      onClick={() => {
        setOpen(!settingScreenOpen)
      }}
    >
      {cookieData.cookieChoiceButton[0]}
    </button>
  )

  let cookieScreen = (
    <>
      <CookieBanner
        disableStyles={true}
        disableButtonStyles={true}
        buttonClasses={"btn_consent"}
        enableDeclineButton={false}
        buttonWrapperClasses={"button_container"}
        buttonText={cookieData.cookieAcceptButtonText}
        containerClasses={"cookie_container"}
        overlay={true}
        overlayClasses={
          "bg-gray-700/50 w-full min-h-screen z-50 fixed overflow-clip"
        }
        flipButtons={true}
        onAccept={() => {
          Cookies.set("gatsby-plugin-google-analytics", "true", {
            expires: 365,
          })
          Cookies.set("gatsby-plugin-google-tagmanager", "true", {
            expires: 365,
          })
          Cookies.set("gatsby-plugin-facebook-pixel", "true", { expires: 365 })
          Cookies.set("gatsby-gdpr-hotjar", "true", { expires: 365 })
          dataLayer.push({ cookieType: "SocialCookies", consent: true })
          dataLayer.push({ cookieType: "StatisticalCookies", consent: true })
          dataLayer.push({ cookieType: "AnalyticalCookies", consent: true })
          dataLayer.push({ event: "pageview" })

          removeOverflow()
        }}
      >
        <div className={"inner_container"}>
          <div className={"text_right"}>
            <h2>
              <RenderRichContent content={cookieData.title} />
            </h2>
            <RenderRichContent content={cookieData.cookieExplainer} />
          </div>
        </div>
        <div className={"customize_btn_container"}>{customizeButton}</div>
      </CookieBanner>
    </>
  )

  if (settingScreenOpen === true) {
    settingScreen = <CookieSettings data={cookieData} dataLayer={dataLayer} />
    cookieScreen = <></>
  }

  if (typeof window !== "undefined") {
    setTimeout(() => {
      // Retrieve iframe after mounting
      const iframe = document.querySelector('iframe[id^="hs-form-iframe-"]')
      const iframeContentWindow = iframe?.contentWindow
      const iframeDocument = iframeContentWindow?.document

      //Function for getting cookievalue
      function getCookieValue(cookieName) {
        var name = cookieName + "="
        var decodedCookie = decodeURIComponent(document.cookie)
        var ca = decodedCookie.split(";")
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i]
          while (c.charAt(0) == " ") {
            c = c.substring(1)
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ""
      }

      // Check if utm cookie exists
      var utmsCookie = getCookieValue("utms")
      if (utmsCookie) {
        var decodedUtms = JSON.parse(atob(utmsCookie))
        var utmField = iframeDocument?.querySelector('input[name="utm"]')
        if (utmField) {
          utmField.value = atob(utmsCookie)
        }
        if (decodedUtms.length > 0) {
          var lastUtm = decodedUtms[decodedUtms.length - 1]
          var utmFields = [
            "utm_id",
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_term",
            "utm_content",
          ]
          utmFields.forEach(function (utmKey) {
            var match = lastUtm.match(new RegExp(utmKey + "=([^&]+)"))
            if (match) {
              var formField = iframeDocument?.querySelector(
                'input[name="' + utmKey + '"]',
              )
              if (formField) {
                formField.value = match[1]
              }
            }
          })
        }
      }
    }, 5000)
  }

  let popupData = data.AllLocale.nodes
  return (
    <>
      {cookieScreen}
      {settingScreen}
     
      <div className={"my-0 mx-auto relative"}>
        <PopUpBrowserLanguage data={popupData} />
        {header ? null : (
          <NewHeader data={headerData} urlContent={urlContent} />
        )}
        <main className={`${header ? "" : "pt-16 lg:pt-28 min-h-[50vh]"} `}>
          {children}
        </main>
        {footer ? null : <Footer data={footerData} />}
      </div>
    </>
  )
}

export default Layout
